import React, { useEffect, useState } from 'react'
import * as BsCheck2 from "react-icons/bs";
import * as FcGoogle from "react-icons/fc";
import image from "../../assets/images/pic95.png"
import image1 from "../../assets/images/pic101.jpg"
import image2 from "../../assets/images/pic100.jpeg"
import image3 from "../../assets/images/pic103.jpeg"
import image4 from "../../assets/images/pic102.jpeg"
import { login } from "../../services/auth/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiFillMail } from "react-icons/ai";
import { auth, provider } from "../../firebase"
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
// import Col from 'react-bootstrap/Col';
import './LandingPage.css'
import { HiOutlineArrowSmRight } from 'react-icons/hi'
import { Link, useNavigate } from "react-router-dom";

import { useLocation } from 'react-router-dom';
import LandingPageSignUp from './LandingPageSignUp';
import LandingForgetPassword from './LandingForgetPassword';
import { useFormik } from "formik";
import * as Yup from "yup";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { BiHide, BiShow } from 'react-icons/bi';

const LandingPage = (props) => {
    let { setToken } = props;
    let navigate = useNavigate();

    const [SignUpModal, setSignUpModal] = useState(false);
    const [ForgetModal, setForgetModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loader, setLoader] = useState(false);
    const [value, setValue] = useState("")
    const location = useLocation();
    const showPasswordHandler = () => {
        setShowPassword(!showPassword);
    };
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Invalid email address").required("Required"),
            password: Yup.string().required("Required"),
        }),
        onSubmit: (values) => {
            setLoader(true);
            login(values)
                .then((res) => {
                    console.log("res : ", res);
                    if (res.user.verified == true) {
                        toast.success("Login Successfully", {
                            theme: "colored",
                        });
                        localStorage.setItem("user", JSON.stringify(res.user));
                        localStorage.setItem("token", res.token);
                        localStorage.setItem("userId", res.user._id);
                        setToken(res.token);
                        navigate("/");
                        setLoader(false);
                    } else {
                        toast.info("please verify your Email", {
                            theme: "colored",
                        });
                        setLoader(false);
                    }
                })
                .catch((e) => {
                    setLoader(false);
                    console.error("Err :", e);
                    toast.error("something went wrong", {
                        theme: "colored",
                    });
                });
        },
        validateOnBlur: true,
        validateOnChange: true,
        validate: (values) => {
            let errors = {};
            if (!values.email) {
                errors.email = "Email is required";
            }
            if (!values.password) {
                errors.password = "Password is required";
            }
            return errors;
        },
    });
    // const handleGoogleLogin = () => {
    //     const auth = getAuth();
    //     signInWithPopup(auth, provider)
    //         .then((result) => {
    //             const credential = GoogleAuthProvider.credentialFromResult(result);
    //             const token = credential.accessToken;
    //             const user = result.user;
    //             console.log("googleUser : ", user);
    //             console.log("googleToken : ", token);
    //             localStorage.setItem("googleUser", JSON.stringify(user));
    //             localStorage.setItem("googleToken", token);
    //             localStorage.setItem("googleUserId", user.uid);
    //             setValue(token);
    //             navigate("/");
    //         })
    //         .catch((error) => {
    //             const errorCode = error.code;
    //             const errorMessage = error.message;
    //             const email = error.email;
    //             const credential = GoogleAuthProvider.credentialFromError(error);
    //             console.log("errorCode : ", errorCode);
    //             console.log("errorMessage : ", errorMessage);
    //             console.log("email : ", email);
    //             console.log("credential : ", credential);
    //         });
    // };
    // useEffect(() => {
    //     setValue(localStorage.getItem("googleToken"))

    // }, []);


    return (
        <div className='container-fluid' style={{ backgroundColor: ' #0C0032' }}>

            <div className="sftfree">
                <div className=" styljira"><b>Roadmap</b></div>
                <div className="stylgit">Get It Free</div>
            </div>
            <div className='row-stylbac '>
                <div class=" stylcolordeiv">
                    <div className='textmain'>
                        <div className='starting'>
                            <div className='software1'>Roadmap<span></span>Features:</div>
                            <span className='each'><br/>Explore the features that help your team succeed:</span>
                        </div>
                        <div className='divtickdiv'>
                            <div className='styconsdiv'>
                                <BsCheck2.BsCheck2 />
                                <h6 >Views <HiOutlineArrowSmRight /> Views your team Projects from every angle</h6>
                            </div>
                            <div className='styconsdiv'>
                                <BsCheck2.BsCheck2 />
                                <h6>Automation <HiOutlineArrowSmRight /> Automate task and workflows
                                    with Butter automation</h6>
                            </div>
                            <div className='styconsdiv'>
                                <BsCheck2.BsCheck2 />
                                <h6>Templates <HiOutlineArrowSmRight /> Give your Team a blueprint for success with easy-to-use templates</h6>
                            </div>
                            <div className='styconsdiv'>
                                <BsCheck2.BsCheck2 />
                                <h6>
                                    Integration <HiOutlineArrowSmRight /> Find the apps your team is already
                                    discover new ways to get work done
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" signgooglediv ">
                    <div className='ContainerModl p-2'>

                        <div className='get'><b>Get started</b></div>
                        <div className='free' >Free for up to 10 users</div>
                        <div className='btngoogdiv' style={{ marginRight: 5 }}>
                            <FcGoogle.FcGoogle />Continue with Google</div>
                        <div style={{ color: 'black', marginTop: '0.5rem' }}>OR</div>
                        <form onSubmit={formik.handleSubmit} className="form-signss">
                            <div className="input-main">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder='Enter Email'
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="input__fields p-1"
                                />
                                <span className={formik.errors.email ? "icon__css" : "cls2"}>
                                </span>
                                {formik.errors.email ? (
                                    <small className="formik__errors" >{formik.errors.email}&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                                ) : null}
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter Password"
                                    name="password"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="input__fields p-1"
                                />
                                <span className={formik.errors.email ? "show___password" :
                                    "show__password"}
                                >
                                    {
                                        showPassword ? <BiHide onClick={showPasswordHandler} /> : <BiShow onClick={showPasswordHandler} />
                                    }
                                </span>

                                {formik.errors.password ? (
                                    <small className="formik__errors">
                                        {formik.errors.password}
                                    </small>
                                ) : null}
                            </div>
                            <div className='Clickingbelow'>By clicking below, you agree to the
                                Roadmap software term of Service and Privacy Policy.</div>
                            {loader ? (
                                <button className='btngoogdivs'>Loading...</button>
                            ) : (
                                <button className='btngoogdivs' type="submit">Login</button>
                            )}
                        </form>

                        <div className="pswfor pt-2" onClick={() => setForgetModal(true)} ><a className='pswforgotdiv'>Forgot password?</a></div>
                        {
                            ForgetModal && <LandingForgetPassword
                                ForgetModal={ForgetModal}
                                setForgetModal={setForgetModal}
                            />
                        }
                        <div className='btngoogdivss' onClick={() => setSignUpModal(true)}>SignUp</div>
                        {
                            SignUpModal && <LandingPageSignUp

                                SignUpModal={SignUpModal}
                                setSignUpModal={setSignUpModal}
                            />
                        }
                        <div className='rodmppdivdiv'>Roadmap</div>
                    </div>
                </div>
                <ToastContainer />
                <br />
            </div>
            <div className='writdiv'>
                <h1 className='jirrdiv'><b>Roadmap Your Way</b></h1>
                <h5 className='eslicustom'>
                    All it takes are boards, lists,
                    and cards to get a clear view of
                    who’s doing what and what needs to get done.
                </h5>
                <div className='imgdivall'>
                    <img src={image} className="jirimgdivall"></img>
                </div>
            </div>
            <div className='divfgriprojediv'>
                <div className='divwritediv' >
                    Roadmap makes it easy for your team to get work done.
                    No matter the project, workflow, or type of team,Roadmap can help keep things organized.
                    It’s simple – sign-up, create a board, and you’re off! Productivity awaits.
                </div>
                <div className='divwritescott'><h2>Meet Roadmap</h2>
                </div>
                <div className='divwritescotts' > <h4 className='manag'>RoadMap Management SoftWare</h4> </div>
                <div className='imgfugdiv'>
                    <img src={image1} style={{ width: '10rem' }}></img>
                </div>
            </div>

            <div className='row-divunfunSet'>
                <div className=' unfunkdin'><h3 className='boardi' style={{color:'white'}}> Roadmap Boards </h3>
                    <div className='divSetupdiv'>
                        Whatever the project or process,
                        boards keep tasks organized and work moving forward.
                        In a glance you can see everything from “things to do” to “aww yeah we did it!”
                    </div></div>

                <div className=' divimgnextgen '>
                    <img src={image2} className="pic-image4" ></img></div>

            </div>

            <div className='row-imgRodmpdivStayTrack '>
                <div className='  '>
                    <img src={image3} className="imgrodmppdiv"></img>
                </div>
                <div className=' Staytrackondiv'>
                    <h4 className='cardtitle' style={{color:'white'}}>Roadmap Cards Title</h4>
                    <div className='divSetupdivs' >
                        Cards represent tasks and can
                        hold all the information you need to get the job done.
                        As you make progress, move cards across lists to show their status.Cards keep all of
                        the information your team needs organized and in one place.
                    </div>
                </div>

            </div>
            <div className='row-divunfunSet'>
                <div className=' unfunkdin'> <h4 className='cardtitle' style={{color:'white'}}>Roadmap List</h4>
                    <div className='divSetupdiv' >
                        The different stages of a task.
                        Start as simple as To Do, Doing,
                        or Done—or build a workflow custom fit to your team’s needs. There’s
                        no wrong way to Trello.
                    </div></div>

                <div className=' divimgnextgen '>
                    <img src={image4} className="pic-images4" ></img></div>

            </div>
            <div className='writetextowner'>
                <h3 className='deardiv'>How To Use Roadmap</h3>
                <div className='busineowner'>
                    RoadMap is the visual tool that empowers your
                    team to manage any type of project, workflow, or
                    task tracking. Add files, checklists, or even automation:
                    Customize it all for how your team works best. Just sign up, create a
                    board, and you’re off!
                    <br />   Roadmap are tool that can be used to manage tasks for small
                    and large projects alike
                    by a single individual or by multi-person teams.
                    What makes this tool popular is how you can visualize tasks.Roadmap service
                    offer a feature called kanban board views,
                    a column-style view that allows users to sort tasks into various
                    states (columns) and move them
                    through a system that can be custom-designed for a particular project.
                    <br />Thank you for Your time,

                </div>
            </div>
            <div className='ConcptTodiv'>
                <div> <h2 className='divlauntimediv'>Roadmap will Create, collaborate and
                    organize your work all in one place.
                </h2>
                    <div className='getfreediv'>Get it Free</div>
                </div>
            </div>
        </div>
    )
}

export default LandingPage